var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAlertIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_0_3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.5 8C14.5 12.173 11.3361 15.5 7.5 15.5C3.66391 15.5 0.5 12.173 0.5 8C0.5 3.82698 3.66391 0.5 7.5 0.5C11.3361 0.5 14.5 3.82698 14.5 8Z",
    stroke: "#637DF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.38776 14C5.95238 14 5.61224 13.9032 5.36735 13.7097C5.12245 13.5161 5 13.2473 5 12.9032C5 12.7742 5.01361 12.6183 5.04082 12.4355C5.06803 12.2527 5.10204 12.0645 5.14286 11.871C5.18367 11.6667 5.22449 11.4785 5.26531 11.3065C5.31973 11.1237 5.36054 10.9677 5.38776 10.8387L6.77551 5.45161L9.10204 5.25806L7.38776 12C7.37415 12.086 7.35374 12.1989 7.32653 12.3387C7.29932 12.4677 7.28571 12.5806 7.28571 12.6774C7.28571 12.8387 7.33333 12.9677 7.42857 13.0645C7.53742 13.1613 7.69388 13.2151 7.89796 13.2258C7.81633 13.4946 7.62585 13.6882 7.32653 13.8065C7.04082 13.9355 6.72789 14 6.38776 14ZM8.44898 4.03226C8.01361 4.03226 7.65306 3.95161 7.36735 3.79032C7.08163 3.61828 6.93878 3.36559 6.93878 3.03226C6.93878 2.67742 7.08844 2.41935 7.38776 2.25806C7.68707 2.08602 8.05442 2 8.4898 2C8.92517 2 9.28571 2.08602 9.57143 2.25806C9.85714 2.41935 10 2.66667 10 3C10 3.35484 9.85034 3.61828 9.55102 3.79032C9.2517 3.95161 8.88435 4.03226 8.44898 4.03226Z",
    fill: "#637DF4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_3"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 16,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertIcon);
export default __webpack_public_path__ + "static/media/alert-icon.e0e6181eabfbd9e833a47d0543f065ed.svg";
export { ForwardRef as ReactComponent };